import { VStack } from "@design-system/VStack/VStack";
import { useEntities } from "@hooks/useEntities";
import { NestedRowRefusalGroup } from "../nestedRowRefusal";

interface Props {
    groups: NestedRowRefusalGroup[];
    // False on a single-business row, where the reason alone already says which
    // business refused.
    shouldNameBusinesses: boolean;
}

// A refused ⋯ item's tooltip: each distinct reason on its own line with the
// businesses holding it named underneath, one per line, matching the entity
// tile's own tooltip. The template host has no real entities behind the ids, so
// a group whose businesses do not resolve renders as the bare reason.
export const NestedRefusalTooltip = ({
    groups,
    shouldNameBusinesses,
}: Readonly<Props>) => {
    const entities = useEntities({ onlyBusiness: true });

    return (
        <VStack gap={8}>
            {groups.map((group) => {
                const groupEntities = shouldNameBusinesses
                    ? entities.filter((entity) =>
                          group.entityIds.includes(entity.id),
                      )
                    : [];
                return (
                    <VStack key={group.reason} gap={2}>
                        <span>
                            {groupEntities.length === 0
                                ? group.reason
                                : `${group.reason}:`}
                        </span>
                        {groupEntities.map((entity) => (
                            <span key={entity.id}>{entity.name}</span>
                        ))}
                    </VStack>
                );
            })}
        </VStack>
    );
};
